class ReviewsDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('#ReviewsDrawer-Overlay');
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    const url = new URL(window.location.href);
    const shouldOpen = url.searchParams.has('reviews') || sessionStorage.getItem('openReviewsDrawer') === 'true';
    sessionStorage.removeItem('openReviewsDrawer');
    if (shouldOpen) {
      this.open();
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      this.classList.add('animate', 'active');
      if (window.jdgm && typeof window.jdgm.init === 'function') {
        window.jdgm.init();
      }
    });
  }

  close() {
    this.classList.remove('active');
    document.body.style.overflow = '';
    const url = new URL(window.location.href);
    if (url.searchParams.has('reviews')) {
      url.searchParams.delete('reviews');
      history.replaceState(null, '', url.pathname + url.search);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('reviews-drawer', ReviewsDrawer);
